module.exports = __webpack_public_path__ + "img/logo.284bf7ba.png";